import { render, staticRenderFns } from "./BackofficeEquipeMedica.vue?vue&type=template&id=fcaf12b8&scoped=true"
import script from "./BackofficeEquipeMedica.vue?vue&type=script&lang=ts"
export * from "./BackofficeEquipeMedica.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeEquipeMedica.vue?vue&type=style&index=0&id=fcaf12b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcaf12b8",
  null
  
)

export default component.exports